module.exports = __webpack_public_path__ + "static/media/autokar2 (2).9cc8522f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (2).jpg
// module id = 849
// module chunks = 0